import { all, fork } from "redux-saga/effects";
import watchJob from "./job";

export default function* root() {
  yield all([fork(watchJob)]);
}
